import React from 'react';
import DefaultSuccess from '../components/PanelsComponents/DefaultPanels/DefaultSuccess';

//= ========================================================================
const Panel_J06_LoanSuccess = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  simPlatform,
  language,
}) => (
  <DefaultSuccess
    globJSON={globJSON}
    onConfigChanged={onConfigChanged}
    onStepPressed={onStepPressed}
    onGotoEdit={onGotoEdit}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    language={language}
  />
);

export default Panel_J06_LoanSuccess;
